<template>
  <el-dialog
    class="create-user-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="form"
      :model="ruleForm"
      status-icon
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="用户名" prop="name">
        <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="属性" prop="attributes">
        <el-select
          v-model="ruleForm.attributes"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="请选择属性集合"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetForm()">重置</el-button>
      <el-button type="primary" @click="submitForm()">提交</el-button>&emsp;
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'CreateUser',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      title: '新建用户',
      userName: '',
      value: '',
      dialogVisible: false,
      resultObj: {},
      options: [],
      ruleForm: {
        name: '',
        attributes: ''
      },
      rules: {},
      adaptationVars: {
        formLabelWidth: 100
      }
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(row) {
      this.$apis.chain
        .getAttributeList()
        .then(res => {
          this.options = res.data.map(item => {
            return { label: item, value: item }
          })
        })
        .catch(err => {
          this.disabled = false
          return
        })

      this.dialogVisible = true
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    submitForm() {
      this.$apis.chain
        .createUser(this.ruleForm)
        .then(res => {
          this.$message.success('新增用户成功')
          this.$emit('handleChildMethod')
          this.handleCancel()
        })
        .catch(err => {
          return
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('create-user-dialog', (), ());
.create-user-dialog.common-dialog {
  @include adaptation((
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    /deep/ {
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
